import {
  PlansTabBillingOptionsValues,
  PlansTabFormValues,
  PlansTabPlanValues,
} from 'src/pages/Settings/memberships/components/plans-tab/types';
import {
  SerializedBillingCycle,
  SerializedPlan,
  SerializedPlanPrice,
  SerializedPlansConfig,
} from 'src/pages/Settings/memberships/types';

const toCents = (value?: string): number | null => {
  if (!value?.trim()) {
    return null;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue) || numericValue < 0) {
    return null;
  }

  return Math.round(numericValue * 100);
};

const serializePlan = (
  plan: PlansTabPlanValues,
  billingOptions: PlansTabBillingOptionsValues,
  sortOrder: number,
): SerializedPlan => {
  const prices: SerializedPlanPrice[] = [];

  if (billingOptions.monthlyEnabled) {
    const monthlyCents = toCents(plan.monthlyPrice);
    if (monthlyCents !== null) {
      prices.push({
        billingCycle: SerializedBillingCycle.Monthly,
        amountCents: monthlyCents,
      });
    }
  }

  if (billingOptions.annualEnabled) {
    const annualCents = toCents(plan.annualPrice);
    if (annualCents !== null) {
      prices.push({ billingCycle: SerializedBillingCycle.Annual, amountCents: annualCents });
    }
  }

  return {
    id: plan.id,
    name: plan.name,
    isActive: plan.enabled,
    isMostPopular: plan.mostPopular,
    callForPricingEnabled: plan.callForPricing,
    prices,
    sortOrder,
  };
};

export const serializePlansConfig = (
  formValues: PlansTabFormValues,
): SerializedPlansConfig => {
  const { billingOptions, plans } = formValues;

  const serializedPlans = plans.map((plan, index) =>
    serializePlan(plan, billingOptions, index),
  );

  return {
    billingOptions,
    plans: serializedPlans,
  };
};
